import { StyleSheet } from 'react-native';
import { theme } from '@socrait/react';

export const filterPanelStyles = StyleSheet.create({
  scrollView: {
    flexGrow: 0,
    width: 250,
    overflow: 'visible',
    overflowX: 'visible',
    zIndex: 99999,
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing.xlarge,
    flexShrink: 0,
    overflow: 'visible',
  },
  optionLabel: {
    fontSize: theme.fontSizes.small,
    lineHeight: theme.lineHeights.regular,
  },
  sectionLabel: {
    fontSize: theme.fontSizes.small,
    fontWeight: theme.fontWeights.bold,
    height: 40, // matches the message panel's button height
    display: 'flex',
    alignItems: 'center',
  },
  section: {
    flexDirection: 'column',
    gap: theme.spacing.xlarge,
    overflow: 'visible',
  },
  sectionContent: {
    paddingHorizontal: theme.spacing.xlarge,
    overflow: 'visible',
  },
  checkboxGroup: {
    flexDirection: 'column',
    gap: theme.spacing.large,
  },
});
